import React, { useCallback, useState, memo } from 'react'

import Button from '@material-ui/core/Button'
import Tooltip from '@material-ui/core/Tooltip'
import makeStyles from '@material-ui/core/styles/makeStyles'

const useStyles = makeStyles({
    speedBtn: {
        minWidth: 'auto !important',
        padding: '0 2px !important',
        fontSize: '10px !important',
        borderRadius: '2px !important',
        backgroundColor: 'white !important'
    }
})
export type VideoSpeedProps = {
    /**
     * Video element from videoRef.current
     */
    videoElement: HTMLVideoElement | null
}

export const VideoSpeed = memo(({ videoElement }: VideoSpeedProps) => {
    const classes = useStyles()
    const [videoSpeed, setVideoSpeed] = useState(1)

    const increaseVideoSpeed = useCallback(() => {
        // React doesn't support playbackRate video attr, so we set it via ref
        if (videoElement) {
            setVideoSpeed(prevSpeed => {
                const newSpeed = prevSpeed === 2 ? 1 : prevSpeed + 0.25
                videoElement.playbackRate = newSpeed
                return newSpeed
            })
        }
    }, [videoElement])

    return (
        <Tooltip title="Change video speed">
            <Button
                color="default"
                onClick={increaseVideoSpeed}
                size="small"
                className={classes.speedBtn}
            >
                <b>{`x${(Math.round(videoSpeed * 100) / 100).toFixed(
                    videoSpeed === 1 || videoSpeed === 2 ? 1 : 2
                )}`}</b>
            </Button>
        </Tooltip>
    )
})
